import React from "react";
import { TIPOS_EMPRESA } from "../constants/empresas";

export default function EmpresasFilters({ filtros, setFiltros, limpiarFiltros }) {
  return (
    <div className="management-card emp-filters-card management-filters-card mb-4">
      <div className="row g-3 align-items-end">
        <div className="col-12 col-md-4">
          <label className="form-label management-label">Buscar</label>
          <input
            type="text"
            className="form-control"
            placeholder="Nombre, RUC, email o telefono"
            value={filtros.search}
            onChange={(e) => setFiltros((prev) => ({ ...prev, search: e.target.value }))}
          />
        </div>
        <div className="col-6 col-md-4">
          <label className="form-label management-label">Estado</label>
          <select
            className="form-select"
            value={filtros.activo}
            onChange={(e) => setFiltros((prev) => ({ ...prev, activo: e.target.value }))}
          >
            <option value="all">Todos</option>
            <option value="1">Activos</option>
            <option value="0">Inactivos</option>
          </select>
        </div>
        <div className="col-6 col-md-4">
          <label className="form-label management-label">Tipo</label>
          <div className="input-group">
            <select
              className="form-select"
              value={filtros.tipo}
              onChange={(e) => setFiltros((prev) => ({ ...prev, tipo: e.target.value }))}
            >
              <option value="all">Todos</option>
              {TIPOS_EMPRESA.map((tipo) => (
                <option key={tipo.value} value={tipo.value}>
                  {tipo.label}
                </option>
              ))}
            </select>
            <button type="button" className="btn management-btn-primary management-btn-tiny" onClick={limpiarFiltros}>
              <i className="bi bi-eraser-fill me-1" />
              Limpiar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}



